<template>
    <span>
        <a :class="buttonClass" @click.prevent="call()" v-if="!processing">
            <i :class="iconClass"></i>{{ computedLabelOn }}
        </a>
        <span :class="buttonClass" v-else>
            <i class="fa fa-spinner fa-spin"></i>{{ computedLabelProcessing }}
        </span>
    </span>
</template>
<script>
    import Processing from './Processing';
    export default {
        mixins: [Processing],
        props: {
            route: {
                type: String,
                required: true
            },
            cssClass: {
                type: String,
                required: false
            },
            icon: {
                type: String,
                required: true
            },
            labelOn: {
                type: String,
                required: false
            },
            labelProcessing: {
                type: String,
                required: false
            }
        },
        computed: {
            buttonClass() {
                return this.cssClass + (this.processing ? ' disabled' : '');
            },
            iconClass() {
                return 'fa fa-' + this.icon;
            },
            computedLabelOn() {
                return this.labelOn ? ' ' + this.labelOn : null;
            },
            computedLabelProcessing() {
                return this.labelProcessing ? ' ' + this.labelProcessing : null;
            }
        },
        methods: {
            call() {
                if (this.processing) {
                    return;
                }
                this.startCall();
                window.axios.get(this.route)
                    .then(this.success)
                    .catch(this.failure);
            },
            failure(error) {
                this.endCall();
                throw new Error(error);
            }
        }
    }
</script>